import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "ant-row" }
const _hoisted_2 = { class: "ant-col ant-col-xs-24 ant-col-md-24" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 500 500"
}, [
  /*#__PURE__*/_createElementVNode("g", {
    id: "freepik--background-simple--inject-76",
    style: {"opacity":"0"}
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M382.22,191.91c-46.1-49.54-161.38-90.52-227.3-70.22-62,19.12-101,95.55-54.68,146.7,53.34,58.89,145.23,83.23,220.68,72.89C389.77,331.84,438.24,252.11,382.22,191.91Z",
      style: {"fill":"#00A09A"}
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M382.22,191.91c-46.1-49.54-161.38-90.52-227.3-70.22-62,19.12-101,95.55-54.68,146.7,53.34,58.89,145.23,83.23,220.68,72.89C389.77,331.84,438.24,252.11,382.22,191.91Z",
      style: {"fill":"#fff","opacity":"0.9"}
    })
  ]),
  /*#__PURE__*/_createElementVNode("g", { id: "freepik--Shadow--inject-76" }, [
    /*#__PURE__*/_createElementVNode("ellipse", {
      id: "freepik--path--inject-76",
      cx: "250",
      cy: "416.24",
      rx: "193.89",
      ry: "11.32",
      style: {"fill":"#f5f5f5"}
    })
  ]),
  /*#__PURE__*/_createElementVNode("g", { id: "freepik--Hourglass--inject-76" }, [
    /*#__PURE__*/_createElementVNode("g", { style: {"opacity":"0.2"} }, [
      /*#__PURE__*/_createElementVNode("polygon", {
        points: "360.73 407.87 297.04 290.15 233.35 407.87 360.73 407.87",
        style: {"fill":"#00A09A"}
      }),
      /*#__PURE__*/_createElementVNode("polygon", {
        points: "360.73 208.72 297.04 326.43 233.35 208.72 360.73 208.72",
        style: {"fill":"#00A09A"}
      })
    ]),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M308.71,278.22l-9.32,17.22a2.67,2.67,0,0,1-4.7,0l-9.32-17.22a10.21,10.21,0,0,1,9-15.06h5.39A10.21,10.21,0,0,1,308.71,278.22Z",
      style: {"fill":"#00A09A"}
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M298.05,378.15,327,390.05a2.67,2.67,0,0,1-1,5.13H268.13a2.67,2.67,0,0,1-1-5.13L296,378.15A2.65,2.65,0,0,1,298.05,378.15Z",
      style: {"fill":"#00A09A"}
    }),
    /*#__PURE__*/_createElementVNode("circle", {
      cx: "297.04",
      cy: "351.8",
      r: "3.71",
      style: {"fill":"#00A09A"}
    }),
    /*#__PURE__*/_createElementVNode("circle", {
      cx: "297.04",
      cy: "313.05",
      r: "1.91",
      style: {"fill":"#00A09A"}
    }),
    /*#__PURE__*/_createElementVNode("circle", {
      cx: "297.04",
      cy: "331.52",
      r: "2.17",
      style: {"fill":"#00A09A"}
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M360.41,402.06H233.67a5.82,5.82,0,0,0-5.8,5.81h0a5.82,5.82,0,0,0,5.8,5.8H360.41a5.82,5.82,0,0,0,5.8-5.8h0A5.82,5.82,0,0,0,360.41,402.06Z",
      style: {"fill":"#00A09A"}
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M360.41,202.92H233.67a5.82,5.82,0,0,0-5.8,5.8h0a5.82,5.82,0,0,0,5.8,5.8H360.41a5.82,5.82,0,0,0,5.8-5.8h0A5.82,5.82,0,0,0,360.41,202.92Z",
      style: {"fill":"#00A09A"}
    })
  ]),
  /*#__PURE__*/_createElementVNode("g", { id: "freepik--Character--inject-76" }, [
    /*#__PURE__*/_createElementVNode("polygon", {
      points: "194.63 405.68 187.58 403.39 191.96 386.76 199.01 389.05 194.63 405.68",
      style: {"fill":"#ff8b7b"}
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M187.47,402.45l7.92,2.57a.54.54,0,0,1,.37.65l-1.65,6.4a1.31,1.31,0,0,1-1.64.85c-2.74-.94-4-1.53-7.49-2.66-2.15-.7-9.21-2.52-12.17-3.48s-1.93-3.86-.59-3.72c6,.63,11.4.35,13.9-.57A2.09,2.09,0,0,1,187.47,402.45Z",
      style: {"fill":"#263238"}
    }),
    /*#__PURE__*/_createElementVNode("polygon", {
      points: "199.01 389.06 191.96 386.76 189.7 395.34 196.76 397.63 199.01 389.06",
      style: {"opacity":"0.2"}
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M218.28,220.72s-12.65,58.55-15.62,79.6c-3.25,23.05-15.46,92.27-15.46,92.27l13.09,3.62s18.14-67.13,23.44-89.54c5.75-24.33,21-86,21-86Z",
      style: {"fill":"#00A09A"}
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M233.92,239.92c-5,11.34-7.47,36-5.53,47.35,3.54-14.55,7.8-31.85,11.09-45.16C238.37,238.25,236.53,234,233.92,239.92Z",
      style: {"opacity":"0.30000000000000004"}
    }),
    /*#__PURE__*/_createElementVNode("polygon", {
      points: "200.62 396.47 186.6 392.61 186.88 386.9 202.66 392.35 200.62 396.47",
      style: {"fill":"#263238"}
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M184.57,402.87a9.63,9.63,0,0,0,2,.36.18.18,0,0,0,.16-.28c-.18-.23-1.73-2.24-2.7-2.18a.65.65,0,0,0-.54.34,1,1,0,0,0-.08,1A2,2,0,0,0,184.57,402.87Zm1.59,0c-1.34-.16-2.26-.5-2.48-.93a.62.62,0,0,1,.07-.63.32.32,0,0,1,.26-.17C184.53,401.08,185.51,402.06,186.16,402.84Z",
      style: {"fill":"#263238"}
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M186.5,403.22h.08a.18.18,0,0,0,.13-.11c0-.08.85-2.06.36-3a.85.85,0,0,0-.62-.45.66.66,0,0,0-.76.3c-.41.72.16,2.53.73,3.18Zm0-3.17a.5.5,0,0,1,.31.26,3.85,3.85,0,0,1-.27,2.39,3.52,3.52,0,0,1-.51-2.53c0-.09.14-.19.39-.14Z",
      style: {"fill":"#263238"}
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M231.74,165.13c-.38.9-.7,1.58-1.05,2.34s-.73,1.46-1.1,2.18c-.74,1.45-1.52,2.86-2.33,4.27a82.48,82.48,0,0,1-5.4,8.18,62,62,0,0,1-6.65,7.59,38.5,38.5,0,0,1-8.68,6.42l-.25.13a5.17,5.17,0,0,1-1.28.46,14.21,14.21,0,0,1-6.87-.27,20,20,0,0,1-5.24-2.44,34,34,0,0,1-7.24-6.56,60.17,60.17,0,0,1-5.27-7.31,65.7,65.7,0,0,1-4.13-7.85,3.24,3.24,0,0,1,5.47-3.35l.1.12c1.65,2,3.44,4.13,5.24,6.07a68.41,68.41,0,0,0,5.58,5.48,27.46,27.46,0,0,0,5.74,4,8.46,8.46,0,0,0,2.47.82,2.74,2.74,0,0,0,1.44-.12l-1.53.59a29.94,29.94,0,0,0,5.61-4.9,61.91,61.91,0,0,0,5-6.42c1.58-2.3,3.08-4.71,4.49-7.19.72-1.23,1.41-2.48,2.06-3.75l1-1.89c.31-.61.65-1.31.89-1.8l.06-.14a6.5,6.5,0,0,1,11.85,5.34Z",
      style: {"fill":"#263238"}
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M215.39,178.71c3.14-8.34,9.81-8.48,12.7-6.27-.21.39-.43.78-.65,1.17a84.91,84.91,0,0,1-5.15,7.91A65.35,65.35,0,0,1,216,188.9c-.72.71-1.46,1.41-2.23,2.09A32,32,0,0,1,215.39,178.71Z",
      style: {"opacity":"0.30000000000000004"}
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M176,172.79l-6.5.24,1.62-6.95a33.54,33.54,0,0,1,6.63,1,2.63,2.63,0,0,1,1.41,4h0A3.91,3.91,0,0,1,176,172.79Z",
      style: {"fill":"#ff8b7b"}
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M179.64,166.92a6.28,6.28,0,0,0-2.15-1.11c-.54,2.84-4,7.63-4,7.63h2.71a2.38,2.38,0,0,0,1.83-.85l1.9-2.28A2.37,2.37,0,0,0,179.64,166.92Z",
      style: {"fill":"#00A09A"}
    }),
    /*#__PURE__*/_createElementVNode("polygon", {
      points: "164.52 169.83 166.34 164.93 171.1 166.09 169.48 173.03 164.52 169.83",
      style: {"fill":"#ff8b7b"}
    }),
    /*#__PURE__*/_createElementVNode("polygon", {
      points: "246.25 408.92 238.84 408.92 238.58 391.75 245.99 391.75 246.25 408.92",
      style: {"fill":"#ff8b7b"}
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M238.45,408.06h8.33a.53.53,0,0,1,.55.51l.4,6.59a1.32,1.32,0,0,1-1.3,1.32c-2.9-.05-4.28-.22-8-.22-2.25,0-9.78.23-12.89.23s-3-3.08-1.71-3.36c5.92-1.24,11.2-3,13.29-4.61A2.07,2.07,0,0,1,238.45,408.06Z",
      style: {"fill":"#263238"}
    }),
    /*#__PURE__*/_createElementVNode("polygon", {
      points: "246 391.76 238.58 391.76 238.72 400.61 246.13 400.61 246 391.76",
      style: {"opacity":"0.2"}
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M232.74,220.72s-2.83,64.41-1.63,85.64c1.32,23.24,4.08,92.11,4.08,92.11h13.58s3.42-67,4.24-90c.89-25,4.92-87.75,4.92-87.75Z",
      style: {"fill":"#00A09A"}
    }),
    /*#__PURE__*/_createElementVNode("polygon", {
      points: "249.32 398.47 234.65 398.47 233.53 393.01 249.72 393.82 249.32 398.47",
      style: {"fill":"#263238"}
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M235.82,409.35a9.69,9.69,0,0,0,2-.26.2.2,0,0,0,.13-.14.19.19,0,0,0-.07-.17c-.24-.17-2.34-1.6-3.25-1.24a.66.66,0,0,0-.4.48,1,1,0,0,0,.22.94A2,2,0,0,0,235.82,409.35Zm1.5-.51c-1.33.26-2.3.22-2.65-.12a.64.64,0,0,1-.12-.62.3.3,0,0,1,.19-.24C235.23,407.67,236.46,408.29,237.32,408.84Z",
      style: {"fill":"#263238"}
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M237.76,409.09a.13.13,0,0,0,.08,0,.18.18,0,0,0,.09-.14c0-.09.17-2.22-.58-2.94a.87.87,0,0,0-.73-.24.66.66,0,0,0-.62.52c-.18.81.93,2.36,1.67,2.8A.15.15,0,0,0,237.76,409.09Zm-1-3a.5.5,0,0,1,.37.15,3.83,3.83,0,0,1,.49,2.36c-.64-.55-1.38-1.73-1.27-2.26,0-.1.08-.22.33-.25Z",
      style: {"fill":"#263238"}
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M261.64,160.94a4.72,4.72,0,0,0-4-5.5h-.08c-2.39-.35-5.39-.71-8.33-.85a147.89,147.89,0,0,0-16.85,0c-2.59.24-5.12.67-7.14,1.06l-.08,0a7.08,7.08,0,0,0-5.39,4.94c-2.42,8.15-5.31,24.79-1.53,60.12h39.65c.28-3.54-.51-15.06.07-29.73A234.86,234.86,0,0,1,261.64,160.94Z",
      style: {"fill":"#263238"}
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M261.26,163.12c-.82,4.74-1.83,11.19-2.53,18,0,0-3.62-7.1-4.28-13.17S259,161.42,261.26,163.12Z",
      style: {"opacity":"0.30000000000000004"}
    }),
    /*#__PURE__*/_createElementVNode("g", { style: {"opacity":"0.2"} }, [
      /*#__PURE__*/_createElementVNode("path", {
        d: "M234.67,164.06a.38.38,0,0,1-.17-.71l12.36-6.41a.38.38,0,0,1,.5.16.38.38,0,0,1-.16.51L234.84,164A.47.47,0,0,1,234.67,164.06Z",
        style: {"fill":"#fff"}
      }),
      /*#__PURE__*/_createElementVNode("path", {
        d: "M240.33,164.64a.33.33,0,0,1-.26-.11l-6.78-6.73a.39.39,0,0,1,0-.53.38.38,0,0,1,.53,0l6.77,6.74a.38.38,0,0,1,0,.53A.36.36,0,0,1,240.33,164.64Z",
        style: {"fill":"#fff"}
      }),
      /*#__PURE__*/_createElementVNode("path", {
        d: "M249.26,154.58a147.71,147.71,0,0,0-16.84,0l-.28,0a4,4,0,0,0,.43,3.07c.94,1.5,2.91,2.34,5.87,2.5l1.11,0c8,0,11.09-4.86,11.22-5.07l.28-.45Z",
        style: {"fill":"#fff"}
      })
    ]),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M233.22,154.52c4.9-1.16,5.76-4.19,5.43-7.52a19.92,19.92,0,0,0-.39-2.48l6.14-5.1,4.51-3.74c-1.25,5.43-2.66,15.32,1,18.94,0,0-3,5-11.43,4.56C231.41,158.79,233.22,154.52,233.22,154.52Z",
      style: {"fill":"#ff8b7b"}
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M238.26,144.52a19.92,19.92,0,0,1,.39,2.48c2.29-.46,5.35-2.9,5.67-5.24a10.66,10.66,0,0,0,.08-2.34Z",
      style: {"opacity":"0.2"}
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M235,118.5c-3.33,2-2.8,7-3.7,10.58,2.12.21,5.46-3.56,5.46-3.56l2-5.73Z",
      style: {"fill":"#263238"}
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M252.71,128.56c-2.13,7.06-3,11.29-7.52,14.24a9.59,9.59,0,0,1-14.92-8.11c0-6.73,3.46-17.15,11.18-18.59A9.7,9.7,0,0,1,252.71,128.56Z",
      style: {"fill":"#ff8b7b"}
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M246.06,134.55c5-5.8-1.25-8.66,3.86-12.69-5.75.27-15.22-.14-16.91-4.08s3.51-9.28,7.84-9.78c5-.58,3.92,5.61,3.92,5.61s19.13-1.19,13.06,7c4.6-.28,3.33,7.16-4.67,13.44C251.15,134.72,246.06,134.55,246.06,134.55Z",
      style: {"fill":"#263238"}
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M256.68,120.71s3.94-1.17,3.81-4.29C261.91,117.4,262.06,120.38,256.68,120.71Z",
      style: {"fill":"#263238"}
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M253.88,135.93a7.91,7.91,0,0,1-4.55,2.77c-2.27.41-2.8-1.69-1.67-3.74,1-1.84,3.43-4.27,5.47-3.76S255.33,134.14,253.88,135.93Z",
      style: {"fill":"#ff8b7b"}
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M241.32,128.38c-.14.58-.56,1-.95.91s-.58-.61-.44-1.19.56-1,.94-.92S241.46,127.79,241.32,128.38Z",
      style: {"fill":"#263238"}
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M234.69,127.05c-.14.58-.56,1-.94.92s-.59-.61-.45-1.19.56-1,.94-.92S234.83,126.47,234.69,127.05Z",
      style: {"fill":"#263238"}
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M236.73,127.76a22.22,22.22,0,0,1-4,4.42,3.42,3.42,0,0,0,2.68,1.09Z",
      style: {"fill":"#ff5652"}
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M237.45,135.31a5.13,5.13,0,0,0,3.85-1.24.16.16,0,0,0,0-.24.18.18,0,0,0-.25,0,4.89,4.89,0,0,1-4.22,1.05.17.17,0,0,0-.2.14.18.18,0,0,0,.14.21Z",
      style: {"fill":"#263238"}
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M243.88,126.76a.27.27,0,0,0,.17,0,.34.34,0,0,0,.17-.46,3.36,3.36,0,0,0-2.47-2,.36.36,0,0,0-.4.3.35.35,0,0,0,.31.39,2.69,2.69,0,0,1,1.92,1.58A.36.36,0,0,0,243.88,126.76Z",
      style: {"fill":"#263238"}
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M233.05,123.07a.32.32,0,0,0,.32-.06,2.89,2.89,0,0,1,2.52-.59.35.35,0,1,0,.22-.67h0a3.64,3.64,0,0,0-3.17.71.35.35,0,0,0-.06.49A.3.3,0,0,0,233.05,123.07Z",
      style: {"fill":"#263238"}
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M262,158.09l.83,1.13.75,1.06c.5.71.95,1.42,1.42,2.13.91,1.43,1.77,2.88,2.6,4.34a95.76,95.76,0,0,1,4.52,9c.7,1.52,1.3,3.1,1.94,4.65s1.18,3.16,1.67,4.78a88.81,88.81,0,0,1,2.6,9.83l.08.38a5.22,5.22,0,0,1-.71,3.94,28.6,28.6,0,0,1-4.55,5.39,23.54,23.54,0,0,1-6,4,21.55,21.55,0,0,1-6.86,1.9,20.48,20.48,0,0,1-3.5.06c-.58,0-1.16-.11-1.74-.2l-.88-.17-1-.25a.46.46,0,0,1-.34-.55l1.38-5.8c0-.05.26-.06.42-.1l.55-.11c.38-.08.75-.17,1.13-.27a15.91,15.91,0,0,0,2.17-.76,15.5,15.5,0,0,0,3.79-2.23,19.16,19.16,0,0,0,5.26-6.85l-.63,4.32c-.86-2.83-1.77-5.63-2.87-8.4s-2.3-5.49-3.61-8.17-2.71-5.33-4.22-7.91c-.74-1.29-1.52-2.56-2.3-3.82l-1.19-1.86-.59-.9-.55-.8-.2-.3A6.49,6.49,0,0,1,262,158.09Z",
      style: {"fill":"#263238"}
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M248.78,209.48,246.63,213l9.33-.37s2.45-6.28-.89-7.27l-1.3.35A8.56,8.56,0,0,0,248.78,209.48Z",
      style: {"fill":"#ff8b7b"}
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M252.62,204.55a6.26,6.26,0,0,0-1.7,1.71c2.54,1.38,6.08,6.08,6.08,6.08l.82-2.58a2.38,2.38,0,0,0-.27-2L256,205.26A2.38,2.38,0,0,0,252.62,204.55Z",
      style: {"fill":"#00A09A"}
    }),
    /*#__PURE__*/_createElementVNode("polygon", {
      points: "247.45 218.42 255.14 217.74 255.96 212.63 246.63 213 247.45 218.42",
      style: {"fill":"#ff8b7b"}
    })
  ]),
  /*#__PURE__*/_createElementVNode("g", { id: "freepik--Clock--inject-76" }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M153.06,96.34l-.51-.86a35.39,35.39,0,0,1,4.57-2.28l.38.93A33.38,33.38,0,0,0,153.06,96.34Z",
      style: {"fill":"#00A09A"}
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M138.46,114l-1-.34A34.81,34.81,0,0,1,149.77,97.3l.59.81A33.7,33.7,0,0,0,138.46,114Z",
      style: {"fill":"#00A09A"}
    }),
    /*#__PURE__*/_createElementVNode("circle", {
      cx: "170.2",
      cy: "125.39",
      r: "30.78",
      style: {"fill":"#00A09A"}
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M195.91,125.39a25.71,25.71,0,1,1-6.72-17.34.06.06,0,0,1,.05,0A25.66,25.66,0,0,1,195.91,125.39Z",
      style: {"fill":"#fff","opacity":"0.6000000000000001"}
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M195.91,125.39a25.71,25.71,0,0,1-43.15,18.89,25.71,25.71,0,0,1,36.43-36.23.06.06,0,0,1,.05,0A25.66,25.66,0,0,1,195.91,125.39Z",
      style: {"fill":"#fff"}
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M170.2,126.89a1.49,1.49,0,0,1-1.06-.44L156.6,113.91a1.5,1.5,0,1,1,2.12-2.12l11.48,11.48,6.63-6.63a1.5,1.5,0,0,1,2.12,2.12l-7.69,7.69A1.51,1.51,0,0,1,170.2,126.89Z",
      style: {"fill":"#263238"}
    })
  ])
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { class: "ant-row" }
const _hoisted_7 = { class: "ant-col ant-col-xs-24 ant-col-md-8" }
const _hoisted_8 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 500 500"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("g", { id: "freepik--background-simple--inject-2" }, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M391.31,163c-13.26,20.82-.43,29-4.24,47.91-5,24.7-32.35,36.45-49.12,56.66-13.56,16.33-13,30-22,46.78-12.37,23-31.79,30.52-56.5,40.62-45.37,18.54-81.13,39.82-96.8-1.6-3.44-9.1-2.54-18.1-10.14-25.21-6.77-6.35-18.72-7.38-25.49-13.55-16.92-15.4-2.05-37.16-8-56.05-5.14-16.23-18.69-16.21-2.09-39.56,12.91-18.15,36-33.49,50.84-51.46,15.79-19.16,25-38.11,51.44-46.74,19.69-6.42,37.4-4.26,57.93-12.71C306.42,96.05,362.49,45,378.5,75.5c3.36,6.43-3.2,18,.2,25.22,3,6.41,10.78,9.33,14.85,14.94C403.31,129.11,403.59,143.74,391.31,163Z",
    style: {"fill":"#00A09A"}
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M391.31,163c-13.26,20.82-.43,29-4.24,47.91-5,24.7-32.35,36.45-49.12,56.66-13.56,16.33-13,30-22,46.78-12.37,23-31.79,30.52-56.5,40.62-45.37,18.54-81.13,39.82-96.8-1.6-3.44-9.1-2.54-18.1-10.14-25.21-6.77-6.35-18.72-7.38-25.49-13.55-16.92-15.4-2.05-37.16-8-56.05-5.14-16.23-18.69-16.21-2.09-39.56,12.91-18.15,36-33.49,50.84-51.46,15.79-19.16,25-38.11,51.44-46.74,19.69-6.42,37.4-4.26,57.93-12.71C306.42,96.05,362.49,45,378.5,75.5c3.36,6.43-3.2,18,.2,25.22,3,6.41,10.78,9.33,14.85,14.94C403.31,129.11,403.59,143.74,391.31,163Z",
    style: {"fill":"#fff","opacity":"0.9"}
  })
], -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("g", { id: "freepik--Shadow--inject-2" }, [
  /*#__PURE__*/_createElementVNode("ellipse", {
    id: "freepik--path--inject-2",
    cx: "250",
    cy: "416.24",
    rx: "193.89",
    ry: "11.32",
    style: {"fill":"#f5f5f5"}
  })
], -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("g", { id: "freepik--OK--inject-2" }, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M280.92,154.5a105,105,0,0,0-210,0c0,45.53,28.12,82.75,69.49,98.84l72.15,28L198.87,257A105.05,105.05,0,0,0,280.92,154.5Z",
    style: {"fill":"#00A09A"}
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M173.57,250a97.84,97.84,0,1,1,97.85-97.84A97.95,97.95,0,0,1,173.57,250Zm0-194.68a96.84,96.84,0,1,0,96.85,96.84A97,97,0,0,0,173.57,55.32Z",
    style: {"fill":"#fff"}
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M104.92,159.27q0-20.34,8.27-32.57a30.58,30.58,0,0,1,23.05-13.83q15.13-1.64,23.33,8.61t8.19,30.3q0,14.57-3.58,24.27a37.41,37.41,0,0,1-10.34,15.62,29.75,29.75,0,0,1-16.86,7q-10.26,1.11-17-2.64t-10.9-13Q104.92,173.83,104.92,159.27Zm18.74-1.92q0,12.59,3.41,17.71a9.31,9.31,0,0,0,9.29,4.49,11.9,11.9,0,0,0,9.35-6.4Q149,167.4,149,153.47q0-11.73-3.45-16.76a9.44,9.44,0,0,0-9.38-4.4q-5.66.62-9.1,6.48T123.66,157.35Z",
    style: {"fill":"#fff"}
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M177.94,109.77l18.74-2v31.39l19.63-33.51,24.93-2.71-22.13,33.75,23.12,49.21-23.08,2.5-12.79-32.77-9.68,14.94V190.8l-18.74,2Z",
    style: {"fill":"#fff"}
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M85.62,74.46a7.63,7.63,0,1,1,7.62-7.63A7.64,7.64,0,0,1,85.62,74.46Zm0-14.25a6.63,6.63,0,1,0,6.62,6.62A6.63,6.63,0,0,0,85.62,60.21Z",
    style: {"fill":"#00A09A"}
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M159.79,277.6a5.1,5.1,0,1,1,5.1-5.09A5.1,5.1,0,0,1,159.79,277.6Zm0-9.19a4.1,4.1,0,1,0,4.1,4.1A4.1,4.1,0,0,0,159.79,268.41Z",
    style: {"fill":"#00A09A"}
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M254.82,72.12A1.84,1.84,0,1,1,253,70.28,1.84,1.84,0,0,1,254.82,72.12Z",
    style: {"fill":"#00A09A"}
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M141.22,270.67a1.84,1.84,0,1,1-1.83-1.84A1.84,1.84,0,0,1,141.22,270.67Z",
    style: {"fill":"#00A09A"}
  })
], -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("g", { id: "freepik--Character--inject-2" }, [
  /*#__PURE__*/_createElementVNode("polygon", {
    points: "328.42 386.28 334.44 409.84 345.73 407.07 339.7 383.5 328.42 386.28",
    style: {"fill":"#ff8b7b"}
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M346,402.26,333.21,405a.81.81,0,0,0-.65.88l.88,9.36a1.7,1.7,0,0,0,2.05,1.46c4-1,5.21-1.54,10.27-2.64,5.92-1.3,8-.95,15-2.47,4.2-.92,4-5.32,2.13-5.33a28.34,28.34,0,0,1-14.18-3.78A3.66,3.66,0,0,0,346,402.26Z",
    style: {"fill":"#263238"}
  }),
  /*#__PURE__*/_createElementVNode("polygon", {
    points: "328.41 386.29 331.52 398.43 342.81 395.66 339.7 383.51 328.41 386.29",
    style: {"opacity":"0.2"}
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M308.3,295.52c-13.44-39.55-24.09-86.2-24.09-86.2l38.35-2.42s5.65,60.56,8.6,88.48c3.06,29,12.59,94.55,12.59,94.55l-17.3,3.51S310.22,331.71,308.3,295.52Z",
    style: {"fill":"#00A09A"}
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M301.9,231.3l-9.31,11.51c2.37,8.88,5.15,18.86,8.19,29.07A200.08,200.08,0,0,0,301.9,231.3Z",
    style: {"opacity":"0.2"}
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M343.49,392.36l-15.86,3.48a1.33,1.33,0,0,1-1.53-.86l-1.75-5.12a1.32,1.32,0,0,1,.94-1.7l17.22-4.05a1.31,1.31,0,0,1,1.61,1.19l.4,5.69A1.3,1.3,0,0,1,343.49,392.36Z",
    style: {"fill":"#263238"}
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M343.49,392.36l-15.86,3.48a1.33,1.33,0,0,1-1.53-.86l-1.75-5.12a1.32,1.32,0,0,1,.94-1.7l17.22-4.05a1.31,1.31,0,0,1,1.61,1.19l.4,5.69A1.3,1.3,0,0,1,343.49,392.36Z",
    style: {"fill":"#fff","opacity":"0.1"}
  }),
  /*#__PURE__*/_createElementVNode("polygon", {
    points: "265.16 385.46 264.45 409.77 276.08 409.61 276.79 385.3 265.16 385.46",
    style: {"fill":"#ff8b7b"}
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M276.36,404.62,264,404.8a.81.81,0,0,0-.81.73l-1,9.35a1.71,1.71,0,0,0,1.72,1.84c4.11-.13,5.41-.47,10.59-.55,6.06-.1,7.37.66,14.47.55,4.3-.07,5-4.42,3.15-4.8A28.4,28.4,0,0,1,279,405.4,3.7,3.7,0,0,0,276.36,404.62Z",
    style: {"fill":"#263238"}
  }),
  /*#__PURE__*/_createElementVNode("polygon", {
    points: "265.16 385.47 264.79 398 276.43 397.83 276.79 385.3 265.16 385.47",
    style: {"opacity":"0.2"}
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M268.06,294.72c3.28-41.61.51-64.05,5.34-84.72l34.9-2.16S297.47,269,291.48,296.66s-12.41,94.85-12.41,94.85l-17.15.21S259.82,327.18,268.06,294.72Z",
    style: {"fill":"#00A09A"}
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M279,394.59l-16.22.25a1.33,1.33,0,0,1-1.34-1.23l-.35-5.36a1.32,1.32,0,0,1,1.27-1.4l17.67-.55a1.32,1.32,0,0,1,1.33,1.57l-1.09,5.65A1.31,1.31,0,0,1,279,394.59Z",
    style: {"fill":"#263238"}
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M279,394.59l-16.22.25a1.33,1.33,0,0,1-1.34-1.23l-.35-5.36a1.32,1.32,0,0,1,1.27-1.4l17.67-.55a1.32,1.32,0,0,1,1.33,1.57l-1.09,5.65A1.31,1.31,0,0,1,279,394.59Z",
    style: {"fill":"#fff","opacity":"0.1"}
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M321.79,137.35l2,3.28L326,144c1.43,2.21,2.92,4.37,4.41,6.48s3.07,4.11,4.66,6a32.13,32.13,0,0,0,4.72,4.58l-4.89-.73a30.8,30.8,0,0,0,5.79-1.8,64,64,0,0,0,6-2.94c2-1.09,4-2.3,6-3.56s4-2.63,5.89-3.91l.16-.1a3.49,3.49,0,0,1,4.76,5,60.25,60.25,0,0,1-5.11,6,68.19,68.19,0,0,1-5.77,5.33,54.85,54.85,0,0,1-6.63,4.67,36.92,36.92,0,0,1-7.93,3.6,5.68,5.68,0,0,1-4.51-.51l-.38-.22a37.93,37.93,0,0,1-7.82-6.19q-1.63-1.64-3.13-3.32t-2.85-3.43c-1.84-2.3-3.53-4.66-5.14-7.07-.8-1.2-1.59-2.41-2.34-3.65s-1.47-2.44-2.23-3.82a7,7,0,0,1,12-7.07Z",
    style: {"fill":"#ff8b7b"}
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M306.63,124c13.55,1.54,23.8,22.52,23.8,22.52l-14,14.87s-6.22-7.42-12.91-16.81C296.25,134.38,295.91,122.79,306.63,124Z",
    style: {"fill":"#263238"}
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M305.56,127.17c-5.21-1.85-21.53.92-21.53.92,4.57,5.85,7.61,54.31,8,82.18,4.95.68,16.71.59,21.12-.43C312.6,198.9,309,146.62,305.56,127.17Z",
    style: {"fill":"#fff"}
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M323.36,141.85a20.73,20.73,0,0,0-20.66-18.22,143.9,143.9,0,0,0-29,3.2,11.37,11.37,0,0,0-8.65,13.76c7.18,30.13,5.29,58.71,7.21,72a93.12,93.12,0,0,0,23.93,2.75s-.29-3.7-.65-9.69c-.13-2.34-3.14-72.48-7.83-78.51,0,0,10.06-1,15.27.82,3.87,21.84,7.49,87.41,7.49,87.42,8.23-.59,14-5.39,13.89-6.76C326,181.81,325.2,157.54,323.36,141.85Z",
    style: {"fill":"#263238"}
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M282.35,102.48c1.53,5.89,3.32,16.25.51,21.91a2.69,2.69,0,0,0,.7,3.34c3.61,2.79,8.25,5.38,15,5,7.09-.43,6.56-4.67,4.76-7.5a2.59,2.59,0,0,0-1.67-1.18c-6.7-1.38-6.78-6.71-5.82-11.83Z",
    style: {"fill":"#ff8b7b"}
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M287.84,106.44l8,5.74a21.33,21.33,0,0,0-.42,3.76c-2.89-.13-7-2.89-7.5-5.86A10.16,10.16,0,0,1,287.84,106.44Z",
    style: {"opacity":"0.2"}
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M304.47,95c1.81-1.2,2.77-9.47,0-12.15,2.86-2.52,1.21-8.13-2.71-9.08s-6.8,1.63-11.85-1.61c-.87,1.18-.37,2.69,1.14,3.57C293.23,77,304.47,95,304.47,95Z",
    style: {"fill":"#263238"}
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M279.89,92.48c1.36,9,1.69,14.39,6.69,18.61,7.53,6.35,18.38,1.1,19.75-8.18,1.24-8.35-1.19-21.72-10.4-24.48A12.59,12.59,0,0,0,279.89,92.48Z",
    style: {"fill":"#ff8b7b"}
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M282.65,100.12c2.41-1.13,1.09-10.79.5-12.69,6.33.88,24.13-3.87,18.27-10.79-4.28-5-16.77.72-22.09-3.59-1.58,1.69.62,3.69.62,3.69s-8.45,2-5,8C268.09,84.43,272.79,101.12,282.65,100.12Z",
    style: {"fill":"#263238"}
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M276.54,80.92c-3.33,2.61-4.64,1.44-6.57-.32-.46,5.13,3.62,5.79,5.51,5.26C276.72,84.26,276.54,80.92,276.54,80.92Z",
    style: {"fill":"#263238"}
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M276.93,100.78a8.58,8.58,0,0,0,5,3.87c2.65.69,3.65-2,2.64-4.65-.91-2.43-3.39-5.71-5.92-5.2S275.49,98.4,276.93,100.78Z",
    style: {"fill":"#ff8b7b"}
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M292.31,93.28c.07.74.51,1.3,1,1.25s.82-.68.75-1.42-.51-1.3-1-1.25S292.25,92.54,292.31,93.28Z",
    style: {"fill":"#263238"}
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M300.64,91.85c.07.74.51,1.3,1,1.26s.82-.69.75-1.43-.51-1.3-1-1.25S300.58,91.11,300.64,91.85Z",
    style: {"fill":"#263238"}
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M297.67,92.72s2.06,4.11,4.09,6c-1.2,1.35-3.48,1-3.48,1Z",
    style: {"fill":"#ff5652"}
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M296,103.32a6,6,0,0,1-4.57-1.57.22.22,0,1,1,.31-.3,5.87,5.87,0,0,0,5.14,1.32.22.22,0,0,1,.26.17.23.23,0,0,1-.18.26A8.39,8.39,0,0,1,296,103.32Z",
    style: {"fill":"#263238"}
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M289.19,92.06a.41.41,0,0,1-.22,0,.45.45,0,0,1-.23-.58,4.4,4.4,0,0,1,3.05-2.6.43.43,0,0,1,.5.36.45.45,0,0,1-.36.51h0a3.48,3.48,0,0,0-2.39,2.08A.43.43,0,0,1,289.19,92.06Z",
    style: {"fill":"#263238"}
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M303.81,87.88a.46.46,0,0,1-.4-.09,3.41,3.41,0,0,0-3-.83.44.44,0,0,1-.54-.3.45.45,0,0,1,.3-.54,4.31,4.31,0,0,1,3.84,1,.45.45,0,0,1,0,.62A.52.52,0,0,1,303.81,87.88Z",
    style: {"fill":"#263238"}
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M274.83,146.2l-1.58,3.54-1.57,3.67c-1,2.46-2,4.93-2.95,7.42a136.9,136.9,0,0,0-4.79,15l-.43,1.87-.21.94-.05.23c0,.09,0,0,0,0a.09.09,0,0,0,0,0,6.15,6.15,0,0,0,.2,2.15,27.7,27.7,0,0,0,1,3.34c.4,1.17.86,2.37,1.36,3.57,2,4.82,4.48,9.77,6.82,14.66l.05.09a3.5,3.5,0,0,1-5.66,4,88,88,0,0,1-10.78-13.69,45,45,0,0,1-4.28-8.38,17.79,17.79,0,0,1-1.22-6c0-.35,0-.72.06-1.08l0-.5,0-.28.16-1.12.31-2.23a112.06,112.06,0,0,1,4.33-17.1q1.39-4.14,3-8.16c.55-1.34,1.12-2.67,1.73-4s1.2-2.59,1.93-4a7,7,0,0,1,12.61,6Z",
    style: {"fill":"#ff8b7b"}
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M272.54,127.15c-15.11,3.81-19.31,23.13-19.31,23.13L272,163.74s4.65-4.87,6.05-16.3C278.72,142,275.6,127,272.54,127.15Z",
    style: {"fill":"#263238"}
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M270.21,200.37l8.73,3.26-6.68,9s-7.55-3.91-6.13-8.26Z",
    style: {"fill":"#ff8b7b"}
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M283,212.4l-2.87,2.75a3.23,3.23,0,0,1-4.17.25l-3.73-2.81,6.68-9,4.15,4.16A3.22,3.22,0,0,1,283,212.4Z",
    style: {"fill":"#ff8b7b"}
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M369.43,151.32l-1.07-4.88a2.13,2.13,0,0,0-2.26-1.66h0a10.35,10.35,0,0,0-4.39,1.4l-6,3.56.53,5.66c2.49,3.84,10.27.4,10.27.4l.64-.25A3.69,3.69,0,0,0,369.43,151.32Z",
    style: {"fill":"#ff8b7b"}
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M354.94,151.92c-.37-1.91.46-3.45.27-5.25-.16-1.57.26-3.33-.24-5.47.6-1,2.77-.18,2.8,2.47.67,2.72,3.66,2.33,4.85,2C362.62,145.7,358.58,152.73,354.94,151.92Z",
    style: {"fill":"#ff8b7b"}
  })
], -1)
const _hoisted_13 = [
  _hoisted_9,
  _hoisted_10,
  _hoisted_11,
  _hoisted_12
]
const _hoisted_14 = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 500 500"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("g", { id: "freepik--background-simple--inject-2" }, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M407.26,297.87c6.69-41.19-43.19-154.32-91.33-191.24-62.43-47.88-143.91-29-180.4,55.09C101.62,239.8,139,319.9,206.86,346.83,267.25,370.82,401.26,347.86,407.26,297.87Z",
    style: {"fill":"#00A09A"}
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M407.26,297.87c6.69-41.19-43.19-154.32-91.33-191.24-62.43-47.88-143.91-29-180.4,55.09C101.62,239.8,139,319.9,206.86,346.83,267.25,370.82,401.26,347.86,407.26,297.87Z",
    style: {"fill":"#fff","opacity":"0.9"}
  })
], -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("g", { id: "freepik--Shadow--inject-2" }, [
  /*#__PURE__*/_createElementVNode("ellipse", {
    id: "freepik--path--inject-2",
    cx: "250",
    cy: "416.24",
    rx: "193.89",
    ry: "11.32",
    style: {"fill":"#f5f5f5"}
  })
], -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("g", { id: "freepik--Warning--inject-2" }, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M77.27,221.53a.43.43,0,0,1-.43-.39l-2.22-26.7A.42.42,0,0,1,75,194a.43.43,0,0,1,.46.39l2.22,26.7a.43.43,0,0,1-.39.46Z",
    style: {"fill":"#00A09A"}
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M78.59,237.39a.43.43,0,0,1-.43-.39l-.67-8.08a.42.42,0,0,1,.39-.46.42.42,0,0,1,.46.39l.67,8.08a.43.43,0,0,1-.39.46Z",
    style: {"fill":"#00A09A"}
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M303.56,313.37H97.08a10.63,10.63,0,0,1-10.37-9.58L75.08,164a8.7,8.7,0,0,1,8.78-9.58H290.33A10.64,10.64,0,0,1,300.71,164l11.63,139.77A8.71,8.71,0,0,1,303.56,313.37Z",
    style: {"fill":"#fff"}
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M303.56,313.77H97.08a11,11,0,0,1-10.77-9.94L74.68,164.05A9.2,9.2,0,0,1,77.05,157,9.1,9.1,0,0,1,83.86,154H290.33a11,11,0,0,1,10.78,10l11.62,139.77a9.09,9.09,0,0,1-9.17,10ZM83.86,154.84A8.3,8.3,0,0,0,75.47,164L87.1,303.76a10.22,10.22,0,0,0,10,9.21H303.56a8.3,8.3,0,0,0,8.38-9.14L300.31,164.05a10.21,10.21,0,0,0-10-9.21Z",
    style: {"fill":"#00A09A"}
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M290.33,154.44H83.86A8.7,8.7,0,0,0,75.08,164H300.71A10.64,10.64,0,0,0,290.33,154.44Z",
    style: {"fill":"#00A09A"}
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M88.69,159.23a1.87,1.87,0,0,1-1.89,2.07,2.3,2.3,0,0,1-2.24-2.07,1.88,1.88,0,0,1,1.89-2.07A2.28,2.28,0,0,1,88.69,159.23Z",
    style: {"fill":"#fff"}
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M97.09,159.23a1.87,1.87,0,0,1-1.89,2.07A2.3,2.3,0,0,1,93,159.23a1.88,1.88,0,0,1,1.89-2.07A2.28,2.28,0,0,1,97.09,159.23Z",
    style: {"fill":"#fff"}
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M105.49,159.23a1.87,1.87,0,0,1-1.89,2.07,2.3,2.3,0,0,1-2.24-2.07,1.88,1.88,0,0,1,1.89-2.07A2.28,2.28,0,0,1,105.49,159.23Z",
    style: {"fill":"#fff"}
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M285.64,295.05H112a8.45,8.45,0,0,1-8.25-7.61L95.59,190a6.92,6.92,0,0,1,7-7.61H276.26a8.45,8.45,0,0,1,8.25,7.61l8.11,97.49A6.92,6.92,0,0,1,285.64,295.05Z",
    style: {"fill":"#f0f0f0"}
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M231.92,199.41l-53.8,64.78a15.39,15.39,0,0,0,8.58,24.88L274,307.94a15.39,15.39,0,0,0,17.55-20.76l-33.47-83.66A15.39,15.39,0,0,0,231.92,199.41Z",
    style: {"fill":"#263238","opacity":"0.1"}
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M112.16,208.49,93.42,259A9.72,9.72,0,0,0,103.48,272l54.73-5.37a9.72,9.72,0,0,0,6.65-15.74l-36-45.1A9.72,9.72,0,0,0,112.16,208.49Z",
    style: {"fill":"#263238","opacity":"0.1"}
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M250.48,183.1l-50.3,73a16.18,16.18,0,0,0,11.2,25.22l92.46,12.31a16.18,16.18,0,0,0,16.64-23.21l-42.16-85.34A16.18,16.18,0,0,0,250.48,183.1Z",
    style: {"fill":"#00A09A"}
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M213.57,274.8a10.22,10.22,0,0,1-7.82-5.67,9,9,0,0,1,.47-9.2l50.43-73.22a8.48,8.48,0,0,1,8.29-3.52,10.2,10.2,0,0,1,7.82,5.67L315,274.41a9,9,0,0,1-.47,9.2,8.47,8.47,0,0,1-8.29,3.53Z",
    style: {"fill":"#fff"}
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M260.65,209.07l5.89.78a7.57,7.57,0,0,1,6.51,7.7l-.4,7.68a5.7,5.7,0,0,1-.09.83l-4.19,23.15a6.23,6.23,0,0,1-7.11,5h0a7.61,7.61,0,0,1-6.51-6.87l-1.69-23.92a5.77,5.77,0,0,1,0-.83l.39-7.69A6.21,6.21,0,0,1,260.65,209.07Zm-.47,51.56,1.6.21a6.78,6.78,0,0,1,5.83,6.89h0a5.57,5.57,0,0,1-6.45,5.25l-1.6-.22a6.77,6.77,0,0,1-5.83-6.88h0A5.56,5.56,0,0,1,260.18,260.63Z",
    style: {"fill":"#00A09A"}
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M131.5,194.26l-13.81,52.37a9.72,9.72,0,0,0,11.27,12l53.57-10.45A9.72,9.72,0,0,0,187.72,232L148,190.05A9.73,9.73,0,0,0,131.5,194.26Z",
    style: {"fill":"#00A09A"}
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M128.85,254.41a5.93,5.93,0,0,1-5.42-1.82,5.81,5.81,0,0,1-1.5-5.48l13.84-52.51a5,5,0,0,1,3.92-3.65,5.94,5.94,0,0,1,5.42,1.83l39.86,42a5.82,5.82,0,0,1,1.51,5.48,5,5,0,0,1-3.92,3.64Z",
    style: {"fill":"#fff"}
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M142.29,206.93l3.41-.67a4.52,4.52,0,0,1,5.08,3.27L152,214.1a4.64,4.64,0,0,1,.11.51L154.28,229a3.73,3.73,0,0,1-3,4.31h0a4.5,4.5,0,0,1-4.92-2.78l-5.54-13.68a4,4,0,0,1-.17-.49l-1.26-4.58A3.76,3.76,0,0,1,142.29,206.93Zm9.65,30.28.93-.18a4,4,0,0,1,4.55,2.92h0a3.36,3.36,0,0,1-2.56,4.3l-.93.18a4,4,0,0,1-4.55-2.91h0A3.37,3.37,0,0,1,151.94,237.21Z",
    style: {"fill":"#00A09A"}
  })
], -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("g", { id: "freepik--Character--inject-2" }, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M388.36,206l-7.76,2.52,6.24,7.38a23.64,23.64,0,0,0,4.55-5.31,2.47,2.47,0,0,0-.88-3.35Z",
    style: {"fill":"#7f3e3b"}
  }),
  /*#__PURE__*/_createElementVNode("polygon", {
    points: "377.03 214.62 381.68 220.27 386.85 215.94 380.6 208.56 377.03 214.62",
    style: {"fill":"#7f3e3b"}
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M390.87,145.68c1.89,5.2,3.63,10.4,5.28,15.67s3.17,10.56,4.5,16.1l.47,2.13.22,1.11.11.56,0,.14,0,.21.06.42a17.53,17.53,0,0,1-.28,5.7,41.89,41.89,0,0,1-2.88,8.72,82.09,82.09,0,0,1-8.56,14.8l-5.19-2.87c1.84-5,3.66-10.11,5-15.06a42.22,42.22,0,0,0,1.38-7.09,8.38,8.38,0,0,0-.12-2.48l-.43-1.56-.56-1.85c-1.57-5-3.36-10.15-5.13-15.27s-3.54-10.29-5.24-15.42Z",
    style: {"fill":"#7f3e3b"}
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M347.68,114.74c.13.63-.09,1.21-.49,1.32s-.84-.33-1-1,.08-1.21.49-1.31S347.55,114.12,347.68,114.74Z",
    style: {"fill":"#263238"}
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M347.65,115.94a24.21,24.21,0,0,1-1.82,6.07,3.58,3.58,0,0,0,3.06-.18Z",
    style: {"fill":"#630f0f"}
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M346,111a.38.38,0,0,1-.31-.16.37.37,0,0,1,.09-.52,3.7,3.7,0,0,1,3.39-.26.37.37,0,0,1,.2.49.38.38,0,0,1-.49.21,2.9,2.9,0,0,0-2.67.17A.33.33,0,0,1,346,111Z",
    style: {"fill":"#263238"}
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M369.11,116.72c.7,7.26-.33,14.29,1.29,20.6,0,0-1.8,5.86-12.53,5.86-11.8,0-5.41-5.86-5.41-5.86,6.5-1.53,6.51-6.31,5.57-10.8Z",
    style: {"fill":"#7f3e3b"}
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M372.69,139.33c.92-1.85,1.53-4.48-.37-5.14-2.09-.73-13.26-1-17.31.4a4.28,4.28,0,0,0-3.07,5.13Z",
    style: {"fill":"#263238"}
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M396.8,402.69a9.77,9.77,0,0,0,2.12-.82.21.21,0,0,0,.12-.19.19.19,0,0,0-.14-.18c-.35-.12-3.45-1.15-4.27-.45a.66.66,0,0,0-.21.64,1.23,1.23,0,0,0,.66,1A2.63,2.63,0,0,0,396.8,402.69Zm1.48-1c-1.36.62-2.46.83-3,.55a.79.79,0,0,1-.44-.66.24.24,0,0,1,.07-.26C395.32,401,397,401.35,398.28,401.73Z",
    style: {"fill":"#00A09A"}
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M398.88,401.89a.21.21,0,0,0,.15-.26c0-.1-.81-2.48-2-3a1.12,1.12,0,0,0-.91-.06h0a.66.66,0,0,0-.51.67c0,1,2.16,2.42,3.14,2.69Zm-2.5-3a.74.74,0,0,1,.5.06,4.93,4.93,0,0,1,1.61,2.4c-1-.45-2.42-1.59-2.44-2.17,0-.05,0-.17.24-.27h0Z",
    style: {"fill":"#00A09A"}
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M342.18,408.8a10.44,10.44,0,0,0,2.25-.31.23.23,0,0,0,.16-.17.23.23,0,0,0-.1-.21c-.31-.19-3.09-1.9-4.05-1.41a.64.64,0,0,0-.35.58,1.26,1.26,0,0,0,.42,1.08A2.7,2.7,0,0,0,342.18,408.8Zm1.66-.6c-1.46.29-2.59.24-3.06-.16a.82.82,0,0,1-.28-.74c0-.16.07-.21.13-.24C341.12,406.81,342.71,407.54,343.84,408.2Z",
    style: {"fill":"#00A09A"}
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M344.38,408.49a.27.27,0,0,0,.12,0,.22.22,0,0,0,.09-.19c0-.1-.22-2.59-1.22-3.41a1.08,1.08,0,0,0-.87-.26h0a.66.66,0,0,0-.65.53c-.18,1,1.54,2.85,2.44,3.34ZM342.64,405a.7.7,0,0,1,.47.17,4.89,4.89,0,0,1,1,2.71c-.89-.68-2-2.1-1.88-2.67,0,0,0-.18.3-.21h.09Z",
    style: {"fill":"#00A09A"}
  }),
  /*#__PURE__*/_createElementVNode("polygon", {
    points: "353.67 408.18 345.77 408.18 345.69 389.9 353.59 389.9 353.67 408.18",
    style: {"fill":"#7f3e3b"}
  }),
  /*#__PURE__*/_createElementVNode("polygon", {
    points: "408.66 401.42 401.06 402.81 395.61 384.82 403.21 383.43 408.66 401.42",
    style: {"fill":"#7f3e3b"}
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M399.62,400.79l8.63-2a.66.66,0,0,1,.76.37l2.86,6.53a1.21,1.21,0,0,1-.85,1.65c-3,.66-4.52.82-8.32,1.72-2.33.55-7.09,1.94-10.32,2.7s-4.27-2.36-3-3c5.66-2.71,7.54-5,9.09-7.2A2,2,0,0,1,399.62,400.79Z",
    style: {"fill":"#263238"}
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M345.86,407.26h8.62a.66.66,0,0,1,.65.54l1.29,7a1.19,1.19,0,0,1-1.19,1.4c-3.11-.05-7.59-.23-11.5-.23-4.57,0-6.2.25-11.56.25-3.24,0-4-3.28-2.64-3.57,6.22-1.36,8.94-1.5,14.41-4.79A3.73,3.73,0,0,1,345.86,407.26Z",
    style: {"fill":"#263238"}
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M388,139.36c7.37,5.19,9.59,18.55,9.59,18.55l-16.7,8.46a79.67,79.67,0,0,1-6.1-16.57C373,141.9,382.76,135.68,388,139.36Z",
    style: {"fill":"#00A09A"}
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M379.65,147.88l6.58,15.76-5.34,2.73a88.92,88.92,0,0,1-4.32-10.32Z",
    style: {"opacity":"0.2"}
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M338.89,174c.06,8.81.59,19.77,1.9,33.37H383c.51-6.2-2.08-35.43,4.21-64.7a3.87,3.87,0,0,0-3.19-4.64,96.6,96.6,0,0,0-10-1.07,155.68,155.68,0,0,0-17.95,0,70.18,70.18,0,0,0-7.19,1A9.58,9.58,0,0,0,341.5,145a83.7,83.7,0,0,0-2.31,16.45C339,165.05,338.86,169.22,338.89,174Z",
    style: {"fill":"#00A09A"}
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M352.21,157.46c-2.79,2-8.13,3-13,3.41.08-1.29.18-2.51.29-3.66,1.31-.69,2.57-1.32,3.76-1.9Z",
    style: {"opacity":"0.2"}
  }),
  /*#__PURE__*/_createElementVNode("g", { style: {"opacity":"0.2"} }, [
    /*#__PURE__*/_createElementVNode("polygon", { points: "345.69 389.9 345.74 400.06 353.63 400.06 353.59 389.9 345.69 389.9" }),
    /*#__PURE__*/_createElementVNode("polygon", { points: "403.21 383.43 395.61 384.83 398.43 394.1 406.03 392.7 403.21 383.43" })
  ]),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M368,108.22c1.15,7.77,2.22,12.25-.78,17.15a10.18,10.18,0,0,1-18-1c-3.09-6.46-4.46-18.09,2.31-23A10.3,10.3,0,0,1,368,108.22Z",
    style: {"fill":"#7f3e3b"}
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M351.84,113.9c-2.93-1.29-2.65-5.9-1.76-7.84-3.39,1.16-8.29,1.83-9.17-1.62s2.11-4.55.28-7.5,4-6.16,6.72-2,9.44,2.3,13.78-1.67c3.16-2.89,7.78.84,5.95,4.61,0,0,9.5-.61,7.61,5.84s-4.56,6.67-3.95,11.26c.42,3.1.78,9.4-2.94,10.29C363.86,126.3,352.64,122.31,351.84,113.9Z",
    style: {"fill":"#263238"}
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M351.78,122.31c-.86.62-1.75,1.28-2.66,2l.05.11a10.51,10.51,0,0,0,4.09,4.51c.57-.55.89-2.4,1.95-2.37,3.17.09,9.3-1.24,10.32-4.82Z",
    style: {"opacity":"0.2"}
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M354.25,113.79a9.45,9.45,0,0,1-.76,5.07c-.9,1.83-2.32.66-2.87-1.59-.5-2-.63-5.41.67-6.41S354,111.51,354.25,113.79Z",
    style: {"fill":"#7f3e3b"}
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M355.77,207.4s6.63,60.32,10.67,82.92c4.43,24.75,27.37,102.43,27.37,102.43l14.14-3S392.16,317.07,390,292.57c-2.31-26.6-7-85.17-7-85.17Z",
    style: {"fill":"#00A09A"}
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M355.77,207.4s6.63,60.32,10.67,82.92c4.43,24.75,27.37,102.43,27.37,102.43l14.14-3S392.16,317.07,390,292.57c-2.2-25.28-2.2-25.23-7-85.17Z",
    style: {"opacity":"0.30000000000000004"}
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M390.65,388c-.06,0,2.4,5.16,2.4,5.16L409,389.75l-1.13-4.82Z",
    style: {"fill":"#263238"}
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M360.6,228.9c10.28,2,7.69,40.65,5.68,60.52-2.44-14-5.77-41.07-8-60.24A3.49,3.49,0,0,1,360.6,228.9Z",
    style: {"opacity":"0.2"}
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M340.79,207.4s-3.36,59-3.43,83.09c-.08,25,5.5,107,5.5,107h13.38s3.6-80.51,5.14-105.1c1.68-26.81,7.17-85,7.17-85Z",
    style: {"fill":"#00A09A"}
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M340.79,207.4s-3.36,59-3.43,83.09c-.08,25,5.5,107,5.5,107h13.38s3.6-80.51,5.14-105.1c1.68-26.81,7.17-85,7.17-85Z",
    style: {"opacity":"0.30000000000000004"}
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M340.5,392.18c-.06,0,.54,5.55.54,5.55H357.3l.63-5Z",
    style: {"fill":"#263238"}
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M357.52,151.74c-1.6.15-2.95.24-4.42.28s-2.87.07-4.3.06c-2.88,0-5.76-.18-8.66-.5a66,66,0,0,1-8.74-1.5,42.55,42.55,0,0,1-8.82-3.13l-.33-.17a5.21,5.21,0,0,1-2.38-7,5.45,5.45,0,0,1,.49-.81,28.16,28.16,0,0,1,4.05-4.33c1.35-1.2,2.7-2.27,4.06-3.29,2.72-2.05,5.5-3.86,8.29-5.62s5.64-3.39,8.51-5,5.76-3.06,8.76-4.45a3,3,0,0,1,3.07,5.06l0,0c-2.51,1.93-5.1,3.84-7.61,5.8s-5,3.89-7.49,5.87-4.86,4-7.13,6c-1.13,1-2.22,2-3.19,3.09a20.48,20.48,0,0,0-2.36,2.88l-2.21-8a36.65,36.65,0,0,0,6.72,1.79,70.8,70.8,0,0,0,7.41.86c2.53.16,5.09.25,7.66.25,1.29,0,2.58,0,3.86,0s2.63-.1,3.75-.16h.13a6,6,0,0,1,.92,11.93Z",
    style: {"fill":"#7f3e3b"}
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M363.12,114.72l-5,1.11s-6.69-.83-8.22,4.21l4,3.38,6.12,1a4.62,4.62,0,0,0,2.83-.46l1.56-.81a2.38,2.38,0,0,0,1.28-1.89l.37-4A2.38,2.38,0,0,0,363.12,114.72Z",
    style: {"fill":"#7f3e3b"}
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M353.36,157.58c-8.41,2.34-18-.58-18-.58l3.53-18.83s8.35-.74,13.57-.85C365.89,137,368.52,153.38,353.36,157.58Z",
    style: {"fill":"#00A09A"}
  })
], -1)
const _hoisted_19 = [
  _hoisted_15,
  _hoisted_16,
  _hoisted_17,
  _hoisted_18
]
const _hoisted_20 = { class: "ant-col ant-col-xs-24 ant-col-md-16" }
const _hoisted_21 = { class: "ui-resposta-mensagem" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "ui-button-content" }, [
  /*#__PURE__*/_createElementVNode("div", null, "OK")
], -1)
const _hoisted_23 = [
  _hoisted_22
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_barra_progresso = _resolveComponent("barra-progresso")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_a_modal, {
      centered: "",
      width: 700,
      visible: _ctx.dados.computedVisivel,
      "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.dados.computedVisivel) = $event)),
      closable: false,
      maskClosable: false,
      title: '',
      footer: false
    }, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _hoisted_3,
            _hoisted_4,
            _createVNode(_component_barra_progresso, {
              visivel: _ctx.props.apresentarBarraProgresso,
              "onUpdate:visivel": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.props.apresentarBarraProgresso) = $event)),
              frase: _ctx.props.fraseBarraProgresso?_ctx.props.fraseBarraProgresso:undefined
            }, null, 8, ["visivel", "frase"])
          ])
        ], 512), [
          [_vShow, _ctx.props.apresentarBarraProgresso]
        ]),
        ((!_ctx.props.apresentarBarraProgresso && _ctx.props.resposta !== undefined))
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  ((_ctx.props.resposta.status === _ctx.EStatusResposta.Sucesso))
                    ? (_openBlock(), _createElementBlock("svg", _hoisted_8, _hoisted_13))
                    : ((_ctx.props.resposta.status === _ctx.EStatusResposta.Alerta || _ctx.props.resposta.status === _ctx.EStatusResposta.DadosInvalidos))
                      ? (_openBlock(), _createElementBlock("svg", _hoisted_14, _hoisted_19))
                      : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("div", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.props.resposta.mensagens, (mensagem, index) => {
                      return (_openBlock(), _createElementBlock("div", { key: index }, [
                        _createElementVNode("h3", _hoisted_21, _toDisplayString(mensagem.titulo), 1),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(mensagem.subMensagens, (subMensagem, indexSub) => {
                          return (_openBlock(), _createElementBlock("span", {
                            class: "ui-resposta-sub-mensagens",
                            key: indexSub
                          }, _toDisplayString(subMensagem), 1))
                        }), 128))
                      ]))
                    }), 128))
                  ])
                ])
              ]),
              _createElementVNode("button", {
                class: "ui-button -primary ui-full",
                type: "button",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.fecharModal()))
              }, _hoisted_23)
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}